module.exports = __webpack_public_path__ + "img/tickets.39fb3f43.webp";